import React from 'react';

interface HighlightMatchProps {
  text: string;
  query: string;
  className?: string;
}

export const HighlightMatch: React.FC<HighlightMatchProps> = ({ text, query, className = '' }) => {
  if (!query || !text) return <span className={className}>{text}</span>;

  // Split text by the query, capturing the matched portions case-insensitively
  const parts = text.split(new RegExp(`(${query})`, 'gi'));

  return (
    <span className={className}>
      {parts.map((part, index) =>
        part.toLowerCase() === query.toLowerCase() ? (
          <mark key={index} className="bg-amber-100/80 text-amber-950 font-medium px-0.5 rounded-[2px]">
            {part}
          </mark>
        ) : (
          <span key={index}>{part}</span>
        )
      )}
    </span>
  );
};
